import { useEffect } from "react";
import "./SelectShoulder.css";
import ProgressBar from "../ProgressBar/ProgressBar";
const SelectShoulder = ({
  setProgressWidth,
  selectedLeftShoulder,
  selectedRightShoulder,
  setSelectedLeftShoulder,
  setSelectedRightShoulder,
  onNext,
}) => {
  useEffect(() => {
    if (selectedLeftShoulder || selectedRightShoulder) {
      setProgressWidth(33);
    } else {
      setProgressWidth(1);
    }
  }, [selectedLeftShoulder, selectedRightShoulder, setProgressWidth]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <div className="content-wrapper">
        <div></div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: "20px",
            alignItems: "center",
          }}
        >
          <div className="content-title">
            진단할 어깨를 선택해 주세요.(좌/우/양쪽)
          </div>
          <div className="shoulder-button-container">
            <div
              className={`shoulder-button ${
                selectedLeftShoulder ? "selected" : ""
              }`}
              onClick={() => {
                setSelectedLeftShoulder((prev) => !prev);
              }}
            >
              Left
            </div>
            <div
              className={`shoulder-button ${
                selectedRightShoulder ? "selected" : ""
              }`}
              onClick={() => {
                setSelectedRightShoulder((prev) => !prev);
              }}
            >
              Right
            </div>
          </div>
        </div>
        <div
          className="next-button"
          onClick={() => {
            if (!selectedLeftShoulder && !selectedRightShoulder) {
              return;
            }
            onNext();
          }}
        >
          다음
        </div>
      </div>
    </div>
  );
};

export default SelectShoulder;
